import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class CommentParentId extends PrimitiveValueObject<string> {
  static create(value: string): CommentParentId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new CommentParentId(value);
  }
}
